export const editMutations = <const>{
	ND_PRIJEMKA_DODAVATEL_SELECT_MAPPER: 'ND_PRIJEMKA_DODAVATEL_SELECT_MAPPER',
	ND_PRIJEMKA_NDOBJEDNAVKA_SELECT_MAPPER: 'ND_PRIJEMKA_NDOBJEDNAVKA_SELECT_MAPPER',
	ND_PRIJEMKA_PRORDERS_SELECT_MAPPER: 'ND_PRIJEMKA_PRORDERS_SELECT_MAPPER',
	ND_PRIJEMKA_DEALER_SELECT_MAPPER: 'ND_PRIJEMKA_DEALER_SELECT_MAPPER',
};

export const listMutations = <const>{
	ND_PRIJEMKA_DODAVATEL_FILTER_SELECT_MAPPER: 'ND_PRIJEMKA_DODAVATEL_FILTER_SELECT_MAPPER',
	ND_PRIJEMKA_VSTUP_PRAC_FILTER_SELECT_MAPPER: 'ND_PRIJEMKA_VSTUP_PRAC_FILTER_SELECT_MAPPER',
	ND_PRIJEMKA_STATUS_PRIJEMKY: 'ND_PRIJEMKA_STATUS_PRIJEMKY',
	ND_PRIJEMKA_NDOBJEDNAVKA_FILTER_SELECT_MAPPER: 'ND_PRIJEMKA_NDOBJEDNAVKA_FILTER_SELECT_MAPPER',
	ND_PRIJEMKA_FILTER_PRORDERS_SELECT_MAPPER: 'ND_PRIJEMKA_FILTER_PRORDERS_SELECT_MAPPER',
};
